<template>
    <div class="quote-segment">
        <figure>
            <blockquote class="quote-segment__quote">
                <p>&quot;{{ segmentData.text || "Quote" }}&quot;</p>
            </blockquote>
            <figcaption class="quote-segment__citation">
                <cite>{{ segmentData.name || "Name" }}, {{ segmentData.date || "Date" }}</cite>
            </figcaption>
        </figure>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        segmentData: Object,
    },
};
</script>

<style lang="scss"></style>
